import { render } from "./LinkWorkItemForm.vue?vue&type=template&id=32b5dc1f&scoped=true"
import script from "./LinkWorkItemForm.vue?vue&type=script&lang=js"
export * from "./LinkWorkItemForm.vue?vue&type=script&lang=js"

import "./LinkWorkItemForm.vue?vue&type=style&index=0&id=32b5dc1f&lang=scss&scoped=true"
import "./LinkWorkItemForm.vue?vue&type=style&index=1&id=32b5dc1f&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b5dc1f"]])

export default __exports__